import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { OAuthClient } from '@app/models';

import { ModalResult, OAuthClientCredentialsModalComponent as ModalComponent } from './oauth-client-credentials-modal.component';

@Injectable({ providedIn: 'root' })
export class OAuthClientCredentialsModalService {
  constructor(private modalService: ModalService) {}

  open(client: OAuthClient, options?: NgbModalOptions) {
    return this.modalService.open<ModalResult>(ModalComponent, { client }, options);
  }
}
